import { IPNNVOption } from '../common/common.types'

export const getKeyIfPertinentNegativeOrNotValueSelected = (pnnvObj: IPNNVOption | null) => {
  // Check if 'pn' or 'nv' exist in the object and have a value
  if (pnnvObj?.pn && pnnvObj?.pn.trim() !== '') {
    return 'PN'
  }
  if (pnnvObj?.nv && pnnvObj?.nv.trim() !== '') {
    return 'NV'
  }
  return null // Return null if neither 'pn' nor 'nv' have a value
}
